import { createIsRecommendedItem } from '@atlaskit/editor-common/quick-insert/is-recommended-item';
import {
	ADD_SUGGESTIONS_TO_CONTENT_SKILL_MENU_ITEM,
	ASK_ROVO_MENU_ITEM,
	CODE_BLOCK_MENU_ITEM,
	DATABASE_MENU_ITEM,
	DECISION_MENU_ITEM,
	DIAGRAM_MENU_ITEM,
	EMOJI_MENU_ITEM,
	JIRA_ISSUE_MENU_ITEM,
	LOOM_MENU_ITEM,
	MEDIA_INSERT_MENU_ITEM,
	MENTION_MENU_ITEM,
	SYNCED_BLOCK_MENU_ITEM,
	TABS_MENU_ITEM,
} from '@atlaskit/editor-common/quick-insert/keys';
import type { QuickInsertPluginOptions } from '@atlaskit/editor-plugin-quick-insert/quick-insert-plugin-type';

type QuickInsertRecommendedItems = Required<
	Pick<QuickInsertPluginOptions, 'isRecommendedItem' | 'maxRecommendedItems'>
>;

/**
 * Recommended `/` menu items per Confluence editor surface.
 * Each list holds the primary items followed by fallbacks, which fill any slot whose primary item
 * isn't available (not registered or hidden) for the current tenant, user, or content type.
 *
 * @see https://hello.atlassian.net/wiki/spaces/egcuc/pages/7165346734/Slash+command+categories
 */
export const fullPageQuickInsertRecommendedItems: QuickInsertRecommendedItems = {
	isRecommendedItem: createIsRecommendedItem([
		ASK_ROVO_MENU_ITEM.key,
		TABS_MENU_ITEM.key,
		DIAGRAM_MENU_ITEM.key,
		DATABASE_MENU_ITEM.key,
		ADD_SUGGESTIONS_TO_CONTENT_SKILL_MENU_ITEM.key,
		// Fallbacks
		LOOM_MENU_ITEM.key,
		SYNCED_BLOCK_MENU_ITEM.key,
		JIRA_ISSUE_MENU_ITEM.key,
		CODE_BLOCK_MENU_ITEM.key,
	]),
	maxRecommendedItems: 5,
};

export const pageCommentQuickInsertRecommendedItems: QuickInsertRecommendedItems = {
	isRecommendedItem: createIsRecommendedItem([
		ASK_ROVO_MENU_ITEM.key,
		EMOJI_MENU_ITEM.key,
		MENTION_MENU_ITEM.key,
		// Fallbacks
		DECISION_MENU_ITEM.key,
	]),
	maxRecommendedItems: 3,
};

export const inlineCommentQuickInsertRecommendedItems: QuickInsertRecommendedItems = {
	isRecommendedItem: createIsRecommendedItem([
		ASK_ROVO_MENU_ITEM.key,
		EMOJI_MENU_ITEM.key,
		MENTION_MENU_ITEM.key,
		// Fallbacks
		MEDIA_INSERT_MENU_ITEM.key,
	]),
	maxRecommendedItems: 3,
};
